import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useNavigate } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import CoursesPage from "@/pages/CoursesPage";
import ConsultingPage from "@/pages/ConsultingPage";
import ServiceDetail from "@/pages/ServiceDetail";
import CourseDetail from "@/pages/CourseDetail";
import ExpertiseDetail from "@/pages/ExpertiseDetail";
import BlogPage from "@/pages/BlogPage";
import BlogPost from "@/pages/BlogPost";
import AdminPage from "@/pages/AdminPage";

const ROUTE_MAP = {
  home: "/",
  courses: "/courses",
  consulting: "/consulting",
  expertise: "/consulting#expertise",
  testimonials: "/courses#testimonials",
  contact: "/courses#contact",
  blog: "/blog",
};

export const scrollToSection = (id) => {
  if (id === "book") {
    window.dispatchEvent(new CustomEvent("open-booking"));
    return;
  }
  const el = document.getElementById(id);
  if (el) {
    if (window.__lenis) {
      window.__lenis.scrollTo(el, { offset: -90, duration: 1.4 });
    } else {
      el.scrollIntoView({ behavior: "smooth" });
    }
    return;
  }
  const route = ROUTE_MAP[id];
  if (route && window.__navigate) window.__navigate(route);
};

const NavCapture = () => {
  const navigate = useNavigate();
  useEffect(() => {
    window.__navigate = navigate;
    return () => {
      window.__navigate = null;
    };
  }, [navigate]);
  return null;
};

function App() {
  return (
    <div className="grain bg-[#ffffff] min-h-screen text-slate-900" data-testid="app-root">
      <BrowserRouter>
        <NavCapture />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/courses" element={<CoursesPage />} />
          <Route path="/consulting" element={<ConsultingPage />} />
          <Route path="/consulting/:id" element={<ServiceDetail />} />
          <Route path="/course/:id" element={<CourseDetail />} />
          <Route path="/expertise/:slug" element={<ExpertiseDetail />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="light" position="bottom-right" toastOptions={{ style: { background: "#ffffff", border: "1px solid #e2e8f0", color: "#0f172a" } }} />
    </div>
  );
}

export default App;
